import { LinearProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { DataGridProProps, GridSlots } from '@mui/x-data-grid-pro';
import { DataGridPro, gridClasses, useGridApiRef } from '@mui/x-data-grid-pro';
import { useEffect } from 'react';
import { useDataGridApiRefContext } from '../../../DataGridApiRefContext';

const Wrapper = styled('div')(() => ({
  flexGrow: 1,
  position: 'relative',
}));
const Container = styled('div')(() => ({
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
}));
const MUIDataGrid = styled(DataGridPro)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 2,

  '& .MuiDataGrid-main': {
    '--DataGrid-containerBackground': '#F1F3F8',
    '--DataGrid-headersTotalHeight': '56px',
    '--DataGrid-topContainerHeight': '56px',
  },

  [`.${gridClasses['row--detailPanelExpanded']}`]: {
    '& .mediaCell': {
      overflow: 'visible',
    },
  },

  '& .MuiDataGrid-columnHeaderTitleContainerContent': {
    flexGrow: 1,
    justifyContent: 'space-between',
  },

  '& .MuiDataGrid-cell': {
    padding: 0,
    borderRight: '1px solid #DDDFE7',
  },

  '& .total': {
    backgroundColor: '#E7ECFA',
    fontWeight: 500,
    '--DataGrid-pinnedBackground': '#E7ECFA',

    '& .MuiDataGrid-cell': {
      padding: `0 ${theme.spacing(1.25)}`,
    },
  },
}));

export function DataGrid(props: DataGridProProps) {
  const apiRef = useGridApiRef();
  const { setApiRef } = useDataGridApiRefContext();

  useEffect(() => {
    setApiRef(apiRef.current);
  }, [apiRef, setApiRef]);

  return (
    <Wrapper>
      <Container>
        <MUIDataGrid
          hideFooter
          disableColumnMenu
          disableColumnSorting
          apiRef={apiRef}
          slots={{
            loadingOverlay: LinearProgress as GridSlots['loadingOverlay'],
          }}
          {...props}
        />
      </Container>
    </Wrapper>
  );
}
